module.exports = __webpack_public_path__ + "static/media/create-feature-disability.b7adab9e.svg";